<div id="home-top" (mouseenter) ="mouseEnter('home-top')">

  <div class="img-top"> </div>

  @if (isAvailable) {
    <div class="content">
      <div class="button-top" (click)="openOrderModal('custom-modal-1')" (keyup.enter)="openOrderModal('custom-modal-1')" tabindex="0" role="button">ORDER ONLINE</div>
      <div (click)="goToBookTable()" (keyup.enter)="goToBookTable()" tabindex="0" role="button" class="button-top" routerLink="/booking/booktable" skipLocationChange >BOOK A TABLE </div>
    </div>
  }

  @if (showTopText) {
    <div class="text-content" style="margin-top: -28%;">
      <div class="text-top">BD DINE OPENING ON 21-08-2020</div>
    </div>
  }

</div>

<app-jw-modal id="custom-modal-1">
  <div style="min-height: 200px;">
    <span class="material-icons close-button" (click)="closeModal('custom-modal-1');" (keyup.enter)="closeModal('custom-modal-1')" tabindex="0" role="button"> cancel </span>
    <app-order-online></app-order-online>
  </div>
</app-jw-modal>



